import { format } from "date-fns";
import { DiscoveryDetailedRevision } from "~/core";
import { TreeNode } from "~/core/slices/help/interfaces";

export const TABS = ["Details", "Fallback", "Summary"];

export const SUMMARY_IDX = 2;

export const FALLBACK_IDX = 1;

export const makeHistoryTree = (
    history: readonly DiscoveryDetailedRevision[],
) => {
    const tree: TreeNode<DiscoveryDetailedRevision> = {
        tag: "$root",
        children: [],
    };
    const map = new Map<number, TreeNode<DiscoveryDetailedRevision>>();

    history.forEach((item) => {
        map.set(item.detailedId, {
            tag: item.detailedId.toString(),
            children: [],
            value: item,
        });
    });
    history.forEach((item) => {
        const node = map.get(item.detailedId);

        if (!node) {
            return;
        }

        if (item.parent) {
            const parentNode = map.get(item.parent);

            if (parentNode) {
                parentNode.children.push(node);
            }
        } else {
            tree.children.push(node);
        }
    });

    return tree;
};

export const getHistoryLabel = (
    item: DiscoveryDetailedRevision | null | undefined,
) => {
    if (!item) {
        return "";
    }

    return `${item.localId} - ${format(item.time, "dd MMM, HH:mm")}`;
};
